// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c4d60391","394":"4c1b7235","775":"2b49cd6d","780":"22fc3cff","881":"92e35064"}[chunkId] + ".chunk.js";
};